import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  UncontrolledCollapse,
} from "reactstrap";
import React from "react";
import { format } from "date-fns";
import { helpers } from "../helpers";

export const ReviewDetailsView = ({ report, review }) => {
  const { contentId, contentType, courseId } = report;

  const contentUrl = helpers.resolveContentUrl(report);

  return (
    <UncontrolledCollapse
      tag={"div"}
      colSpan={7}
      toggler={"#toggler" + report._id}
      style={{
        backgroundColor: "grey",
      }}
    >
      <Row
        style={{
          display: "flex",
          paddingTop: "10px",
          paddingLeft: "10px",
          paddingBottom: "20px",
          paddingRight: "10px",
        }}
      >
        <Card>
          <CardHeader>Inhalt</CardHeader>
          <CardBody>{report.contentDetails}</CardBody>
        </Card>
      </Row>
      <Row
        style={{
          display: "flex",
          paddingTop: "10px",
          paddingLeft: "10px",
          paddingBottom: "20px",
          paddingRight: "10px",
        }}
      >
        <Col>
          <Card>
            <CardHeader>Beschreibung des Melders </CardHeader>
            <CardBody>{report.description}</CardBody>
          </Card>
        </Col>
        <Col>
          <Card>
            <CardHeader>Nachricht an Melder </CardHeader>
            <CardBody>{review.messageToReporter}</CardBody>
          </Card>
        </Col>
        <Col>
          <Card>
            <CardHeader>Nachricht an Content-Creator </CardHeader>
            <CardBody>{review.messageToContentCreator}</CardBody>
          </Card>
        </Col>
        <Col>
          <Card>
            <CardHeader>Notiz an Blagoom</CardHeader>
            <CardBody>{review.noteToBlag}</CardBody>
          </Card>
        </Col>
        <Col>
          <Card>
            <CardHeader>Reviewer</CardHeader>
            <CardBody>
              {review.reviewer.username +
                ", " +
                format(
                  new Date(parseInt(review.updatedAt)),
                  "dd/MM/yyyy HH:mm",
                )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row
        style={{
          padding: "10px",
          display: "flex",
          justifyContent: "space-between",
          paddingRight: "30px",
          paddingLeft: "20px",
        }}
      >
        <div>
          <a href={contentUrl} target="_blank">
            <Button color="secondary">Link zum Content</Button>
          </a>
        </div>
      </Row>
    </UncontrolledCollapse>
  );
};
